export const APP_VERSION = '1.2.4-30';
